import { useTranslations } from 'next-intl'
import { INVOICE_TYPES } from '@/constants'
import {
  IInvoiceDetailsMasterNode,
  IUnpaidInvoiceMasterNode,
} from '@/types/billing.interface.js'
import { useFormatInvoiceDate } from '@/hooks/useFormatInvoiceDate'
import { getInvoiceDisplayDetails } from '@/utils/getInvoiceDisplayDetails'

const InvoiceTitle = ({
  detail,
}: {
  detail: IInvoiceDetailsMasterNode | IUnpaidInvoiceMasterNode
}) => {
  const t = useTranslations()

  const formattedDate = useFormatInvoiceDate(
    detail?.invoiceMonth ?? 0,
    detail?.invoiceYear ?? 0
  )

  if (!detail) {
    console.error('No invoice detail found')
    return null
  }
  let displayTitle: string

  if (detail?.invoiceType === INVOICE_TYPES.HOSTING) {
    displayTitle = formattedDate
  } else {
    const { title } = getInvoiceDisplayDetails(detail)
    displayTitle = t(title)
  }

  return <>{displayTitle}</>
}

export default InvoiceTitle
